import type { ReactNode } from 'react';
import type { ColumnDef } from '@tanstack/react-table';
import { PCMP_CHANNEL_LABELS } from '../../constants/pcmpProposal.constants';
import type { PcmpAccountsQueueItem, PcmpAccountsTab } from '../../types/pcmpAccounts.types';
import { getPcmpQueueColumns } from '../PcmpQueue/pcmpQueueColumns';
import { PcmpAccountsAttemptCell } from './PcmpAccountsCells';

const ATTEMPT_HEADER: Partial<Record<PcmpAccountsTab, string>> = {
  DISBURSEMENT_FAILED: 'Failure',
  RETURNED: 'Return',
  COMPLETED: 'Payout',
};

interface PcmpAccountsColumnOptions<T extends PcmpAccountsQueueItem> {
  /** The queue tab; left out for a batch's members. */
  tab?: PcmpAccountsTab | undefined;
  leading?: ColumnDef<T>[] | undefined;
  renderActions: (item: T) => ReactNode;
}

export function getPcmpAccountsColumns<T extends PcmpAccountsQueueItem>({
  tab,
  leading,
  renderActions,
}: PcmpAccountsColumnOptions<T>): ColumnDef<T>[] {
  return getPcmpQueueColumns<T>({
    leading,
    afterAmounts: [
      {
        id: 'payment',
        header: 'Payment',
        cell: ({ row }) => (
          <div className="flex flex-col whitespace-nowrap">
            <span>{row.original.paymentTypeLabel}</span>
            {row.original.paymentSource !== 'ACCOUNTS' ? (
              <span className="text-xs text-muted-foreground">
                Source: {PCMP_CHANNEL_LABELS[row.original.paymentSource]}
              </span>
            ) : null}
          </div>
        ),
      },
    ],
    afterLanes: [
      {
        id: 'lastAttempt',
        header: (tab && ATTEMPT_HEADER[tab]) ?? 'Last Payout',
        cell: ({ row }) => <PcmpAccountsAttemptCell attempt={row.original.lastAttempt} />,
      },
    ],
    renderActions,
  });
}
